import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

export const LoadingScreenContainer = styled.div``;
export const LoadingImage = styled.img`
  display: block;

  inline-size: 150px;
  block-size: 150px;
  margin-block: 0 12.1px;
  margin-inline: auto;

  animation: fade-in-out 2s linear infinite;
  @keyframes fade-in-out {
    0%,
    100% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
  }

  ${theme.breakpoints.up("tablet")} {
    margin-block: 0 15.6px;
    margin-inline: auto;
  }
`;

export const LoadingText = styled.div`
  color: #d7d7d7;
  font-size: 16px;
  line-height: 18.75px;
  text-align: center;

  i {
    font-weight: 400;
    font-style: italic;
  }

  span {
    font-weight: 700;
  }
`;
